import React from 'react';
import FollowupInput from './FollowupInput';
import { iFollowupItem } from 'interfaces/iFollowupItem';

interface FollowupQuestionsDisplayProps {
  followupItems: iFollowupItem[];
  onSubmitFollowup: any;
  isStreaming: boolean;
  userProductDesc?: string;
}

const FollowupQuestionsDisplay: React.FC<FollowupQuestionsDisplayProps> = ({
  followupItems,
  onSubmitFollowup,
  isStreaming,
  userProductDesc
}) => {
  return (
    <>
      <div className='classify'>
        <div className='classify-found'>
          <div className='classify-header'>
          Item / Product Name
          </div>
          <div className='classify-cont'>
            <div className='classify-cont-sec'>
              <div className='classify-cont-sec-div'>
                <div className='classify-cont-sec-input'>
                  {userProductDesc}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='classify-follow-up'>
        Generated Follow-Up Questions
        </div>

        {
          isStreaming && followupItems.length < 0 && (
            <div className='loading-spinner-cont' style={{ marginTop: '0%' }}>
              <svg className='spinner' xmlns='http://www.w3.org/2000/svg' width='32' height='33' viewBox='0 0 32 33' fill='none'>
                <g clipPath='url(#clip0_4006_13811)'>
                  <circle cx='16' cy='3.75' r='3' fill='white' fillOpacity='0.1' />
                  <circle opacity='0.45' cx='16' cy='29.75' r='3' fill='white' fillOpacity='0.65' />
                  <circle cx='3' cy='16.75' r='3' fill='white' fillOpacity='0.85' />
                  <circle cx='29' cy='16.75' r='3' fill='white' fillOpacity='0.35' />
                  <circle cx='26' cy='7.75' r='3' fill='white' fillOpacity='0.25' />
                  <circle cx='26' cy='25.75' r='3' fill='white' fillOpacity='0.45' />
                  <circle cx='6' cy='25.75' r='3' fill='white' fillOpacity='0.75' />
                  <circle cx='6' cy='7.75' r='3' fill='white' />
                </g>
                <defs>
                  <clipPath id='clip0_4006_13811'>
                    <rect width='32' height='32' fill='white' transform='translate(0 0.75)' />
                  </clipPath>
                </defs>
              </svg>
            </div>
          )
        }

        <FollowupInput
          followupItems={followupItems}
          isStreaming={isStreaming}
          onSubmitFollowup={onSubmitFollowup} />
      </div>

    </>
  );
};

export default FollowupQuestionsDisplay;
